import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
  selector: 'app-usuarios-sig-vobo',
  templateUrl: './usuarios-sig-vobo.component.html',
  styleUrls: ['./usuarios-sig-vobo.component.scss']
})
export class UsuariosSigVoboComponent implements OnInit {
  
  constructor(
    @Inject(MAT_DIALOG_DATA) public data : any,
  ) { }

  ngOnInit(): void {
    console.log(this.data)
  }

}
